export const PAGINATION_ITEMS_PER_PAGE = 10;
export const USER_PROFILE_PHOTO_DEFAULT = "files/users/usr_default.png"
export const PLAYER_PROFILE_PHOTO_DEFAULT = "files/players/usr_default.png"

export const LABELS = Object.freeze({
    SELECT_ALL: "-- TODOS --", 
    SELECT: "-- SELECCIONAR --", 
});

export const STATUS = Object.freeze({
    ACTIVE: "Activo",
    INACTIVE: "Inactivo"
});

export const PLAYER_PROFILE = Object.freeze({
    CAPTAIN: "Capitán",
    PLAYER: "Jugador"
});

export const PLAY_TYPES = Object.freeze({
    QUIZ: 1,
    UPLOAD_CONTENT_IMAGE: 2,
    UPLOAD_CONTENT_VIDEO: 3,
    VIDEO_RECOMENDATION: 4,
    READING: 5,
    COMBINE:6
});
 
export const QUESTION_TYPE = Object.freeze({
    OPEN: 1,
    CLOSED:2,
    SEMIOPEN: 4  
});

export const MATCH_ICON = Object.freeze({
    SCHEDULED: 1,
    PLAYING:2,
    PLAYED:3,
    NOT_PLAYED:4 
});

export const MATCH_LABEL = Object.freeze({
    CLOSED: 'Cerrado' 
});

export const PLAY_ICON = Object.freeze({
    SCHEDULED: 1,
    PLAYING:2,
    PLAYED:3,
    NOT_PLAYED:4 
});


export const MEDIA = Object.freeze({
    DESKTOP: 1200,
    TABLET: 599
});

export const SOCIAL_NETWORKS = Object.freeze({
    TWITTER: 1,
    FACEBOOK: 2,
    WHATSAPP:3
});


export const TOURNAMENT_STATUS = Object.freeze({
    NO_INICIADO: 1,
    EN_CURSO: 2,
    TERMINADO: 3
});


export const MATCH_STATUS = Object.freeze({
    NO_INICIADO: 1,
    EN_CURSO: 2,
    TERMINADO: 3
});


export const PLAY_STATUS = Object.freeze({
    NO_INICIADO: 1,
    EN_CURSO: 2,
    TERMINADO: 3
});

export const INTERACTIONS_TYPES = Object.freeze({
    LIKES: 1,
    CHEERS: 2,
    GOALS: 3
});

export const IMG_DEFAULT_PROOF = Object.freeze({
    QUIZ: 'https://thumbs.dreamstime.com/b/patr%C3%B3n-de-preguntas-sin-problemas-del-vector-fondo-cuestionario-marcadores-dibujos-animados-amarillo-161783991.jpg',
    VIDEO_RECOMENDATION: 'https://icon-library.com/images/background-icon/background-icon-12.jpg'
});


export const MULTIMEDIA_TYPES = Object.freeze({
    IMAGE: 1,
    VIDEO: 2,
    FILE: 3,
    LINK: 4,
    AUDIO: 5
});


export const COMPANY_TYPES = Object.freeze({
    PROMOTOR: 1,
    PARTICIPANTE: 2
});

export const TEMPLATE_TYPES = Object.freeze({
    JUGADORES: 1,
    EQUIPOS: 2,
    EQUIPOS_JUGADORES:3
});

export const PLAYERCOMPLAINT_STATUS = Object.freeze({
    REGISTRADO: 1,
    APROBADO: 2,
    RECHAZADO:3
});

export const DOCUMENT_TYPE = Object.freeze({
    DNI: 1,
    CARNET_EXTRANJERIA: 2,
    PASAPORTE: 3
  });

  export const NOTIFICATION_TYPE = Object.freeze({
    EMAIL: 1,
    In_APP: 2
});

export const ANSWER_TYPES = Object.freeze({
    SELECCION_UNICA: 1,
    SELECCION_MULTIPLE: 2
});